import React, { Component } from 'react';
import { Form, Control } from 'react-redux-form';

import Textfield from '../../../ui/text-field';
import Datepicker from '../../../ui/datepicker';
import FileUpload from '../../../ui/file-upload';
import Select from '../../../ui/select';

import validators from '../../../../helpers/validators';
import * as endpoints from '../../../../helpers/endpoints';
import apiRequest from '../../../../helpers/apiRequest';
import _ from 'lodash';
import LineItem from './line-item';

class BasicInfo extends Component {
    state = {
        vendorsDropdown: []
    };

    handleSubmit = e => {
        if (this.props.eventId) {
            if (e.id) {
                // this.updateLineItem(e);
                let canSave = this.updateLineItem(e);
                if (canSave) {
                    this.props.updatePurchaseRequest(e);
                }
            } else {
                // this.updateLineItem(e);
                let canSave = this.updateLineItem(e);
                if (canSave) {
                    this.props.createPurchaseRequest(e);
                }
            }
        } else {
            // this.updateLineItem(e);
            let canSave = this.updateLineItem(e);
            if (canSave) {
                this.props.storePurchaseRequest(e);
            }
        }
    };

    updateLineItem = e => {
        let object = this.props.purchaseRequest.newItem;
        if (
            object.name ||
            object.description ||
            object.quantity ||
            object.unitPrice
        ) {
            if (
                object.vendorId &&
                object.unitOfIssue &&
                object.name &&
                object.description &&
                object.quantity &&
                object.unitPrice
            ) {
                this.props.updateLineItem(object);
                this.props.clearLineItem({
                    purchaseRequestId: this.props.purchaseRequest.id,
                    unitOfIssue: 'EACH',
                    vendorId: ''
                });
                return true;
            } else {
                alert(
                    'You need to fill the entire line item before adding another entry or submitting the purchase request.'
                );
                return false;
            }
        } else {
            return true;
        }
    };

    removeLineItem = e => {
        const target = e.target;
        const index = target.getAttribute('data-index');
        const data = this.props.purchaseRequest.PurchaseRequestItem[index];
        if (data.purchaseRequestId) {
            apiRequest(
                `${endpoints.PURCHASE_REQUEST_ITEM}/delete`,
                this.props.jwtToken,
                'POST',
                JSON.stringify({ data })
            )
                .then(response => {
                    this.props.removeLineItem(index);
                })
                .catch(error => {
                    console.log(error);
                });
        } else {
            this.props.removeLineItem(index);
        }
    };

    scrollToTop() {
        window.scrollTo(0, 0);
        const that = this;
        setTimeout(function() {
            that.props.clearAAError();
        }, 10000);
        setTimeout(function() {
            that.props.clearMessage();
        }, 10000);
    }

    uploadFile = e => {
        let files = e.target.files;
        for (let i = 0; i < files.length; i++) {
            let file = files[i];
            let formData = new FormData();
            formData.append('userfile', file);
            apiRequest(
                `${endpoints.MEDIA_UPLOAD}`,
                this.props.jwtToken,
                'POST',
                formData,
                true
            )
                .then(response => {
                    let filesArray = response.data[0];
                    this.props.handleFiles(filesArray);
                })
                .catch(error => {
                    console.log(error);
                });
        }
    };

    componentDidMount() {
        if (!this.props.purchaseRequest.id) {
            let data = {
                eventId: this.props.eventId
            };
            this.props.createPurchaseRequestId(JSON.stringify({ data }));
        }

        if (
            this.props.eventId &&
            this.props.eventId !== this.props.purchaseRequest.eventId
        ) {
            this.props.fetchPurchaseRequest(this.props.eventId);
            this.props.setEventId(this.props.eventId);
            const vendorsArr = this.props.eventVendors;
            let vendors = [];
            for (let i = 0; i < vendorsArr.length; i++) {
                let vendor = vendorsArr[i];
                let vendorObj = {
                    code: vendor.id,
                    name: vendor.name
                };
                vendors.push(vendorObj);
            }
            this.setState({ vendorsDropdown: vendors });
            this.props.setVendorsDropdown(vendors);
        } else if (this.props.eventVendors) {
            const vendorsArr = this.props.eventVendors;
            let vendors = [];
            for (let i = 0; i < vendorsArr.length; i++) {
                let vendor = vendorsArr[i];
                let vendorObj = {
                    code: vendor.id,
                    name: vendor.name
                };
                vendors.push(vendorObj);
            }
            this.setState({ vendorsDropdown: vendors });
            this.props.setVendorsDropdown(vendors);

            if (vendorsArr.length === 1) {
                this.props.setDefaultVendorPR(vendors[0].code);
            }
        } else {
            this.props.clearPurchaseRequest({});
        }
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.purchaseRequest.newItem !==
            this.props.purchaseRequest.newItem
        ) {
            let newItem = nextProps.purchaseRequest.newItem;
            let qty = newItem.quantity;
            let price = newItem.unitPrice;
            if (qty && price) {
                let numQty = +qty;
                let numPrice = +price;
                let total = numQty * numPrice;
                this.props.updateTotalNewLine(total);
            }
        }

        if (
            nextProps.purchaseRequest.PurchaseRequestItem !==
            this.props.purchaseRequest.PurchaseRequestItem
        ) {
            let prItems = nextProps.purchaseRequest.PurchaseRequestItem;
            let prArray = [];

            for (let i = 0; i < prItems.length; i++) {
                let item = prItems[i];
                let qty = item.quantity;
                let price = item.unitPrice;
                let numberPrice = +price;
                let numberQty = +qty;

                let value = numberPrice * numberQty;
                let numberValue = +value;
                this.props.updateTotalLine(i, numberValue);
                prArray.push(numberValue);
            }
            let updatedValue = _.sum(prArray);
            this.props.updateTotalAmount(updatedValue);
        }

        if (nextProps.successMessage && !this.props.successMessage) {
            this.scrollToTop();
        } else if (!nextProps.aaError && this.props.aaError) {
            this.scrollToTop();
        }
    }

    render() {
        let lineItem = this.props.purchaseRequest.PurchaseRequestItem.map(
            (item, index) => {
                return (
                    <LineItem
                        key={index}
                        clin={index + 1}
                        index={index}
                        vendors={this.props.vendorsDropdown}
                        addItem={this.updateLineItem}
                        deleteItem={this.removeLineItem}
                        disabled={!this.props.eventSaveSubmit}
                        saveSubmit={this.props.eventSaveSubmit}
                    />
                );
            }
        );

        const required = validators.required();

        return (
            <Form
                className="form"
                model="PurchaseRequest"
                encType="multipart/form-data"
                onSubmit={this.handleSubmit}
            >
                <div className="tab__title">BASIC INFO & LINE ITEM</div>

                <div className="form__section-title">GENERAL</div>
                <Textfield
                    model="PurchaseRequest.name"
                    title="PR NAME"
                    isRequired
                    validators={{ required }}
                    messages={{ required: required.message }}
                    disabled={!this.props.eventSaveSubmit}
                />

                <Textfield
                    model="PurchaseRequest.totalCost"
                    title="Actual Price"
                    type="number"
                    isRequired
                    validators={{ required }}
                    messages={{ required: required.message }}
                    disabled={!this.props.eventSaveSubmit}
                    onKeyPress
                    min="0"
                />

                <Datepicker
                    model="PurchaseRequest.createdAt"
                    title="DATE CREATED"
                    isRequired
                    validators={{ required }}
                    messages={{ required: required.message }}
                    disabled={!this.props.eventSaveSubmit}
                />

                <Datepicker
                    model="PurchaseRequest.dateRequired"
                    isRequired
                    validators={{ required }}
                    messages={{ required: required.message }}
                    title="DATE REQUIRED"
                    disabled={!this.props.eventSaveSubmit}
                />

                <Textfield
                    model="PurchaseRequest.contactName"
                    isRequired
                    validators={{ required }}
                    messages={{ required: required.message }}
                    title="POC Name"
                    disabled={!this.props.eventSaveSubmit}
                />

                <Textfield
                    model="PurchaseRequest.contactPhone"
                    title="POC Phone"
                    isRequired
                    validators={{ required }}
                    messages={{ required: required.message }}
                    type="tel"
                    maxLength="10"
                    disabled={!this.props.eventSaveSubmit}
                />

                <Textfield
                    model="PurchaseRequest.contactEmail"
                    title="POC EMAIL"
                    isRequired
                    validators={{ required }}
                    messages={{ required: required.message }}
                    type="email"
                    disabled={!this.props.eventSaveSubmit}
                />

                <div className="table__container">
                    <table className="table table--line-items">
                        <thead className="table__thead">
                            <tr className="table__thead-row">
                                <th className="table__header">CLIN</th>
                                <th className="table__header">Vendor</th>
                                <th className="table__header">Item Name</th>
                                <th className="table__header">QTY</th>
                                <th className="table__header">Price</th>
                                <th className="table__header">Unit of Issue</th>
                                <th className="table__header">Amount</th>
                                <th className="table__header">
                                    Line Item Description
                                </th>
                                <th className="table__header" />
                            </tr>
                        </thead>
                        <tbody className="table__tbody">
                            {this.props.eventSaveSubmit && (
                                <tr className="table__row">
                                    <td className="table__cell table__cell--first">
                                        <span className="table__cell-title">
                                            CLIN
                                        </span>
                                        <span className="table__cell-id" />
                                    </td>
                                    <td className="table__cell">
                                        <span className="table__cell-title">
                                            Vendor
                                        </span>
                                        <Select
                                            model="PurchaseRequest.newItem.vendorId"
                                            options={this.props.vendorsDropdown}
                                        />
                                    </td>
                                    <td className="table__cell">
                                        <span className="table__cell-title">
                                            Item Name
                                        </span>
                                        <Textfield model="PurchaseRequest.newItem.name" />
                                    </td>
                                    <td className="table__cell">
                                        <span className="table__cell-title">
                                            QTY
                                        </span>
                                        <Textfield
                                            model="PurchaseRequest.newItem.quantity"
                                            type="number"
                                            onKeyPress
                                            min="0"
                                        />
                                    </td>
                                    <td className="table__cell">
                                        <span className="table__cell-title">
                                            Price
                                        </span>
                                        <Textfield
                                            model="PurchaseRequest.newItem.unitPrice"
                                            type="number"
                                            onKeyPress
                                            min="0"
                                        />
                                    </td>
                                    <td className="table__cell">
                                        <span className="table__cell-title">
                                            Unit of Issue
                                        </span>
                                        <Textfield
                                            model="PurchaseRequest.newItem.unitOfIssue"
                                            disabled
                                        />
                                    </td>
                                    <td className="table__cell">
                                        <span className="table__cell-title">
                                            Amount
                                        </span>
                                        <Textfield
                                            model="PurchaseRequest.newItem.total"
                                            type="number"
                                            disabled
                                            onKeyPress
                                            min="0"
                                        />
                                    </td>
                                    <td className="table__cell">
                                        <span className="table__cell-title">
                                            Line Item Description
                                        </span>
                                        <Textfield model="PurchaseRequest.newItem.description" />
                                    </td>
                                    <td className="table__cell line-items">
                                        <span
                                            onClick={this.updateLineItem}
                                            className="line-items__btn"
                                        >
                                            <svg className="icon icon-plus">
                                                <use
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    xlinkHref="#icon-plus"
                                                />
                                            </svg>
                                        </span>
                                    </td>
                                </tr>
                            )}
                            {lineItem}
                        </tbody>
                    </table>
                </div>

                <Textfield
                    model="PurchaseRequest.itemizedCost"
                    title="Total Amount"
                    type="number"
                    disabled
                    onKeyPress
                    min="0"
                />

                <FileUpload
                    model="PurchaseRequest.fileUpload"
                    title="Document (Choose file to upload)"
                    onChange={this.uploadFile}
                    disabled={!this.props.eventSaveSubmit}
                />
                <div className="files files__left">
                    <div className="form__title">Attached Documents</div>
                    <ul>
                        {this.props.purchaseRequest.Documents.map(
                            (item, index) => (
                                <div
                                    className="files__entry"
                                    key={index}
                                    data-index={index}
                                >
                                    <div className="files__name">
                                        <span className="files__type">
                                            <svg className="icon icon-image">
                                                <use
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    // xlinkHref="#icon-image"
                                                    xlinkHref={`#icon-${
                                                        item.mediaType
                                                    }`}
                                                />
                                            </svg>
                                        </span>
                                        {item.name}
                                    </div>

                                    <div className="files__actions">
                                        <a
                                            className="files__download"
                                            target="_blank"
                                            href={`https://${
                                                endpoints.envCheck
                                            }ems.marines.com${
                                                item.links[0].self
                                            }`}
                                        >
                                            <svg className="icon icon-download">
                                                <use
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    xlinkHref="#icon-download"
                                                />
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                            )
                        )}
                        {this.props.purchaseRequest.Photos.map(
                            (item, index) => (
                                <div
                                    className="files__entry"
                                    key={index}
                                    data-index={index}
                                >
                                    <div className="files__name">
                                        <span className="files__type">
                                            <svg className="icon icon-image">
                                                <use
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    // xlinkHref="#icon-image"
                                                    xlinkHref={`#icon-${
                                                        item.mediaType
                                                    }`}
                                                />
                                            </svg>
                                        </span>
                                        {item.name}
                                    </div>

                                    <div className="files__actions">
                                        <a
                                            target="_blank"
                                            className="files__download"
                                            href={`https://${
                                                endpoints.envCheck
                                            }ems.marines.com${
                                                item.links[0].self
                                            }`}
                                        >
                                            <svg className="icon icon-download">
                                                <use
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    xlinkHref="#icon-download"
                                                />
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                            )
                        )}
                    </ul>
                </div>
                <Control.text
                    model="PurchaseRequest.hidden"
                    type="hidden"
                    value="eventId"
                />

                <div className="form__actions form__actions--global">
                    {this.props.eventSaveSubmit ? (
                        <button type="submit" className="btn btn--submit">
                            Save Purchase Request
                        </button>
                    ) : null}
                </div>
            </Form>
        );
    }
}

export default BasicInfo;



// WEBPACK FOOTER //
// ./src/components/event/purchase-request/basic-info-line-item/index.js